// Pedido mínimo da loja (decisão 0017, spec pagamento-valor-minimo). Base: produtos com promoção menos o cupom de
// produto, sem frete e sem o desconto da forma de pagamento — a mesma da api (OrderMinimumService). Mudou um lado,
// mudar o outro.

// Quanto falta em produtos para o pedido mínimo (0 quando atingiu ou a empresa não tem mínimo)
export function faltaParaPedidoMinimo(baseProdutos, valorMinimo) {
  const minimoCents = Math.round((Number(valorMinimo) || 0) * 100);
  if (minimoCents <= 0) return 0;
  const baseCents = Math.round((Number(baseProdutos) || 0) * 100);
  return baseCents >= minimoCents ? 0 : (minimoCents - baseCents) / 100;
}
